import { useTranslation } from 'react-i18next';

export const EEIngredients = () => {
  const { t } = useTranslation();

  const cultures = [
    {
      flag: '🇸🇷',
      culture: t('ee_ing_surinamese'),
      text: t('ee_ing_surinamese_text'),
      border: 'border-amber-600/15',
    },
    {
      flag: '🇮🇳',
      culture: t('ee_ing_hindustani'),
      text: t('ee_ing_hindustani_text'),
      border: 'border-red-600/15',
    },
    {
      flag: '🌍',
      culture: t('ee_ing_worldwide'),
      text: t('ee_ing_worldwide_text'),
      border: 'border-orange-600/15',
    },
  ];

  return (
    <section id="ingredienten" className="w-full py-20 bg-gradient-to-b from-[#0d0000] to-[#0a0000]">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12">

        {/* Header */}
        <div className="text-center mb-14">
          <p className="text-red-400 text-xs font-semibold uppercase tracking-widest mb-3">{t('ee_ing_badge')}</p>
          <h2 className="text-3xl lg:text-4xl font-black text-white mb-4">
            {t('ee_ing_title').split(' ').slice(0, -1).join(' ')}{' '}
            <span className="text-transparent bg-gradient-to-r from-amber-400 to-red-400 bg-clip-text">
              {t('ee_ing_title').split(' ').slice(-1)[0]}
            </span>
          </h2>
          <p className="text-white/45 text-sm max-w-xl mx-auto leading-relaxed">
            {t('ee_ing_sub')}
          </p>
        </div>

        {/* Hero banner */}
        <div className="relative rounded-2xl overflow-hidden border border-amber-600/20 mb-12">
          <img
            src="https://public.readdy.ai/ai/img_res/1fc66cfeaae06b170fe2e70ffae68949.jpg"
            alt="Hing kerningredient"
            className="w-full h-48 lg:h-64 object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#0d0000]/97 via-[#0d0000]/80 to-[#0d0000]/40" />
          <div className="absolute inset-0 flex items-center px-8 lg:px-12">
            <div>
              <p className="text-amber-400 text-xs font-semibold uppercase tracking-widest mb-2">{t('ee_ing_promise_badge')}</p>
              <h3 className="text-white font-black text-xl lg:text-2xl mb-3">
                {t('ee_ing_promise_title').split('.')[0]}.<br />
                <span className="text-amber-300">{t('ee_ing_promise_title').split('.').slice(1).join('.').trim()}</span>
              </h3>
              <p className="text-white/50 text-sm max-w-lg leading-relaxed">
                {t('ee_ing_promise_desc')}
              </p>
            </div>
          </div>
        </div>

        {/* Main ingredient card */}
        <div className="max-w-2xl mx-auto mb-12">
          <div className="bg-gradient-to-br from-[#1a0500] to-[#0d0000] border border-amber-600/25 rounded-2xl p-8">
            <div className="flex items-start gap-5 mb-5">
              <div className="w-14 h-14 flex items-center justify-center rounded-2xl border border-amber-600/25 bg-black/30 shrink-0">
                <i className="ri-fire-line text-amber-300 text-2xl" />
              </div>
              <div>
                <h4 className="text-white font-bold text-lg">{t('ee_ing_name')}</h4>
                <p className="text-white/30 text-sm italic mt-0.5">{t('ee_ing_latin')}</p>
              </div>
            </div>
            <p className="text-white/60 text-sm leading-relaxed mb-5">{t('ee_ing_desc')}</p>
            <div className="flex items-start gap-2 mb-6">
              <div className="w-4 h-4 flex items-center justify-center shrink-0 mt-0.5">
                <i className="ri-map-pin-2-line text-white/25 text-xs" />
              </div>
              <p className="text-white/35 text-sm leading-relaxed">{t('ee_ing_origin')}</p>
            </div>
            <div>
              <p className="text-white/25 text-xs mb-3 uppercase tracking-wider">{t('ee_ing_found_in')}</p>
              <div className="flex flex-wrap gap-2">
                {['Zeep', 'Baby Pasta', 'Hing Poeder', 'Hing Olie', 'Spray', 'Cologne'].map(prod => (
                  <span
                    key={prod}
                    className="px-3 py-1 text-sm rounded-full border border-amber-600/25 bg-black/20 text-amber-300 font-medium"
                  >
                    {prod}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Cultural context */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {cultures.map(c => (
            <div key={c.culture} className={`p-6 bg-[#1a0000]/50 border ${c.border} rounded-2xl`}>
              <span className="text-2xl block mb-3">{c.flag}</span>
              <h4 className="text-amber-300 font-bold text-sm mb-2">{c.culture}</h4>
              <p className="text-white/50 text-xs leading-relaxed">{c.text}</p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};
